import { NgxSpinnerService } from 'ngx-spinner';
import { Component, OnInit, Output, EventEmitter, ɵConsole } from '@angular/core';
import { Validators, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { FormService } from 'src/app/services/form.service';
import { UserService } from 'src/app/services/user.service';
import { BorradorStorageService } from '../../../services/borrador-storage.service';
@Component({
  selector: 'app-crear-borradores',
  templateUrl: './crearBorrador.component.html',
  styleUrls: ['./crearBorrador.component.css'],
  providers: [UserService]
})
export class crearBorradorComponent implements OnInit {

  // @Output() borradorGuardado = new EventEmitter<boolean>();

  borradorFormControl = new FormControl('', [
    Validators.required
  ]);

  public matcher = new FormService();
  public borradores;

  constructor(private _userService: UserService, private snackbar: MatSnackBar,
    private dialog: MatDialog, private spinner: NgxSpinnerService,
    private borradorStorageService: BorradorStorageService
  ) { }

  ngOnInit() {

    this.borradores = this.allStorage();
  }

  saveDraft() {
    //console.log("/////////saveDraft////////////////")
    this.spinner.show();
    this._userService.saveDraft(this.borradorFormControl.value, this.borradores).subscribe(
      response => {
        // console.log('saveDraft response',response)
        // console.log('saveDraft response.id._id',response.id._id)
        if (response.borrador) {
          sessionStorage.setItem("borrador", response.id._id);

          this.borradorStorageService.cambioStorage();



          // this.borradorGuardado.emit(true);

          this.dialog.closeAll();
          this.spinner.hide();

          this.snackbar.open('Borrador guardado con exito', 'Aceptar', {
            duration: 1500
          });

        }
      },
      error => {
        console.log(error)
        this.spinner.hide();
      }
    )


  }

  allStorage() {
    console.log(localStorage)

    return Object.keys(localStorage)
      .reduce((obj, k) => {
        if (k == 'form' || k == 'formId' || k == 'formTitle') {// para que 3.10 llegue completo                    
          return { ...obj, [k]: typeof localStorage[k] !== 'undefined' ? localStorage.getItem(k) : '' }
        } else {
          return { ...obj, [k]: typeof localStorage[k] !== 'undefined' ? JSON.parse(localStorage.getItem(k)) : '' }

        }
        /*   return { ...obj, [k]: JSON.parse(localStorage.getItem(k)) } */
      }, {});
  }


}
